import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=320ac222&"
import script from "./termsOfService.vue?vue&type=script&lang=js&"
export * from "./termsOfService.vue?vue&type=script&lang=js&"
import style0 from "./termsOfService.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports